import { createAction, props } from '@ngrx/store';
import { ErrorModel } from './models/error.model';

export const SetErrorAction = createAction(
  '[Error] Set',
  props<{ payload: { error: ErrorModel } }>()
);

export const ClearErrorAction = createAction('[Error] Clear');
